import { Component, ReactNode } from 'react';
import { logger } from '@fiverr-private/obs';

interface ErrorBoundaryProps {
    children?: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    override componentDidCatch(error: any) {
        logger.error(error);
    }

    override render() {
        const { hasError } = this.state;

        if (hasError) {
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
